Object.defineProperties(document, {
    lang: {
        get() {
            return this.documentElement.lang;
        },
        set(lang) {
            this.documentElement.setAttribute('lang', lang);
        }
    },
    preferredLang: {
        get() {
            return [document.lang, ...navigator.languages.filter(n => n).map(n => n.slice(0, 2)), "en"].uniq()
        }
    },
    languageInfo: {
        value: {
            xx: {flag: "🏳️‍", name: "Unspecific", local: "Unspecific"},
            ca: {flag: "🇪🇸", name: "Catalan", local: "Català"},
            ar: {flag: "🇦🇪", name: "Arabic", local: "العربية"},
            ps: {flag: "🇦🇫", name: "Pashto", local: "پښتو"},
            uz: {flag: "🇺🇿", name: "Uzbek", local: "O'zbek"},
            en: {flag: "🇬🇧", name: "English", local: "English"},
            sq: {flag: "🇦🇱", name: "Albanian", local: "Shqip"},
            hy: {flag: "🇦🇲", name: "Armenian", local: "Հայերեն"},
            ru: {flag: "🇷🇺", name: "Russian", local: "Русский"},
            pt: {flag: "🇵🇹", name: "Portuguese", local: "Português"},
            de: {flag: "🇩🇪", name: "German", local: "Deutsch"},
            nl: {flag: "🇳🇱", name: "Dutch", local: "Nederlands"},
            sv: {flag: "🇸🇪", name: "Swedish", local: "Svenska"},
            az: {flag: "🇦🇿", name: "Azerbaijani", local: "Azərbaycan"},
            bs: {flag: "🇧🇦", name: "Bosnian", local: "Bosanski"},
            hr: {flag: "🇭🇷", name: "Croatian", local: "Hrvatski"},
            sr: {flag: "🇷🇸", name: "Serbian", local: "Српски"},
            bn: {flag: "🇧🇩", name: "Bengali", local: "বাংলা"},
            fr: {flag: "🇫🇷", name: "French", local: "Français"},
            ff: {flag: "🇨🇳", name: "Fula", local: "Fulfulde"},
            bg: {flag: "🇧🇬", name: "Bulgarian", local: "Български"},
            rn: {flag: "🇧🇮", name: "Kirundi", local: "Kirundi"},
            ms: {flag: "🇲🇾", name: "Malay", local: "Melayu"},
            be: {flag: "🇧🇾", name: "Belarusian", local: "Беларуская"},
            ln: {flag: "🇨🇬", name: "Lingala", local: "Lingála"},
            sw: {flag: "🇹🇿", name: "Swahili", local: "Kiswahili"},
            lu: {flag: "🇨🇩", name: "Luba-Katanga", local: "Luba-Katanga"},
            sg: {flag: "🇨🇫", name: "Sango", local: "Sango"},
            it: {flag: "🇮🇹", name: "Italian", local: "Italiano"},
            el: {flag: "🇬🇷", name: "Greek", local: "Ελληνικά"},
            tr: {flag: "🇹🇷", name: "Turkish", local: "Türkçe"},
            cs: {flag: "🇨🇿", name: "Czech", local: "Čeština"},
            da: {flag: "🇩🇰", name: "Danish", local: "Dansk"},
            et: {flag: "🇪🇪", name: "Estonian", local: "Eesti"},
            ti: {flag: "🇪🇹", name: "Tigrinya", local: "ትግርኛ"},
            fi: {flag: "🇫🇮", name: "Finnish", local: "Suomi"},
            hi: {flag: "🇮🇳", name: "Hindi", local: "हिन्दी"},
            ur: {flag: "🇵🇰", name: "Urdu", local: "اردو"},
            fo: {flag: "🇫🇴", name: "Faroese", local: "Føroyskt"},
            ka: {flag: "🇬🇪", name: "Georgian", local: "ქართული"},
            kl: {flag: "🇬🇱", name: "Greenlandic", local: "Kalaallisut"},
            hu: {flag: "🇭🇺", name: "Hungarian", local: "Magyar"},
            id: {flag: "🇮🇩", name: "Indonesian", local: "Bahasa Indonesia"},
            ga: {flag: "🇮🇪", name: "Irish", local: "Gaeilge"},
            he: {flag: "🇮🇱", name: "Hebrew", local: "עברית"},
            fa: {flag: "🇮🇷", name: "Persian", local: "فارسی"},
            is: {flag: "🇮🇸", name: "Icelandic", local: "Íslenska"},
            ja: {flag: "🇯🇵", name: "Japanese", local: "日本語"},
            km: {flag: "🇰🇭", name: "Khmer", local: "ខ្មែរ"},
            ko: {flag: "🇰🇷", name: "Korean", local: "한국어"},
            kk: {flag: "🇰🇿", name: "Kazakh", local: "Қазақ"},
            si: {flag: "🇱🇰", name: "Sinhala", local: "සිංහල"},
            lt: {flag: "🇱🇹", name: "Lithuanian", local: "Lietuvių"},
            lv: {flag: "🇱🇻", name: "Latvian", local: "Latviešu"},
            ro: {flag: "🇷🇴", name: "Romanian", local: "Română"},
            mg: {flag: "🇲🇬", name: "Malagasy", local: "Malagasy"},
            mk: {flag: "🇲🇰", name: "Macedonian", local: "Македонски"},
            my: {flag: "🇲🇲", name: "Burmese", local: "မြန်မာ"},
            mt: {flag: "🇲🇹", name: "Maltese", local: "Malti"},
            af: {flag: "🇿🇦", name: "Afrikaans", local: "Afrikaans"},
            nb: {flag: "🇳🇴", name: "Norwegian Bokmål", local: "Norsk Bokmål"},
            ne: {flag: "🇳🇵", name: "Nepali", local: "नेपाली"},
            pl: {flag: "🇵🇱", name: "Polish", local: "Polski"},
            rw: {flag: "🇷🇼", name: "Kinyarwanda", local: "Kinyarwanda"},
            sl: {flag: "🇸🇮", name: "Slovenian", local: "Slovenščina"},
            sk: {flag: "🇸🇰", name: "Slovak", local: "Slovenčina"},
            so: {flag: "🇸🇴", name: "Somali", local: "Af-Soomaali"},
            th: {flag: "🇹🇭", name: "Thai", local: "ไทย"},
            to: {flag: "🇹🇴", name: "Tongan", local: "faka-Tonga"},
            uk: {flag: "🇺🇦", name: "Ukrainian", local: "Українська"},
            vi: {flag: "🇻🇳", name: "Vietnamese", local: "Tiếng Việt"},
            sn: {flag: "🇿🇼", name: "Shona", local: "ChiShona"},

            AD: {flag: "🇦🇩", name: "Andorra", local: "Andorra"},
            AE: {flag: "🇦🇪", name: "United Arab Emirates", local: "الإمارات العربية المتحدة"},
            AF: {flag: "🇦🇫", name: "Afghanistan", local: "افغانستان"},
            AG: {flag: "🇦🇬", name: "Antigua and Barbuda", local: "Antigua and Barbuda"},
            AI: {flag: "🇦🇮", name: "Anguilla", local: "Anguilla"},
            AL: {flag: "🇦🇱", name: "Albania", local: "Shqipëri"},
            AM: {flag: "🇦🇲", name: "Armenia", local: "Հայաստան"},
            AO: {flag: "🇦🇴", name: "Angola", local: "Angola"},
            AQ: {flag: "🇦🇶", name: "Antarctica", local: "Antarctica"},
            AR: {flag: "🇦🇷", name: "Argentina", local: "Argentina"},
            AS: {flag: "🇦🇸", name: "American Samoa", local: "Amerika Sāmoa"},
            AT: {flag: "🇦🇹", name: "Austria", local: "Österreich"},
            AU: {flag: "🇦🇺", name: "Australia", local: "Australia"},
            AW: {flag: "🇦🇼", name: "Aruba", local: "Aruba"},
            AX: {flag: "🇦🇽", name: "Åland Islands", local: "Åland"},
            AZ: {flag: "🇦🇿", name: "Azerbaijan", local: "Azərbaycan"},
            BA: {flag: "🇧🇦", name: "Bosnia and Herzegovina", local: "Bosna i Hercegovina"},
            BB: {flag: "🇧🇧", name: "Barbados", local: "Barbados"},
            BD: {flag: "🇧🇩", name: "Bangladesh", local: "বাংলাদেশ"},
            BE: {flag: "🇧🇪", name: "Belgium", local: "België"},
            BF: {flag: "🇧🇫", name: "Burkina Faso", local: "Burkina Faso"},
            BG: {flag: "🇧🇬", name: "Bulgaria", local: "България"},
            BH: {flag: "🇧🇭", name: "Bahrain", local: "البحرين"},
            BI: {flag: "🇧🇮", name: "Burundi", local: "Burundi"},
            BJ: {flag: "🇧🇯", name: "Benin", local: "Bénin"},
            BL: {flag: "🇧🇱", name: "Saint Barthélemy", local: "Saint-Barthélemy"},
            BM: {flag: "🇧🇲", name: "Bermuda", local: "Bermuda"},
            BN: {flag: "🇧🇳", name: "Brunei", local: "بروناي"},
            BO: {flag: "🇧🇴", name: "Bolivia", local: "Bolivia"},
            BQ: {flag: "🇧🇶", name: "Bonaire, Sint Eustatius and Saba", local: "Bonaire, Sint Eustatius and Saba"},
            BR: {flag: "🇧🇷", name: "Brazil", local: "Brasil"},
            BS: {flag: "🇧🇸", name: "Bahamas", local: "The Bahamas"},
            BT: {flag: "🇧🇹", name: "Bhutan", local: "འབྲུག"},
            BV: {flag: "🇧🇻", name: "Bouvet Island", local: "Bouvetøya"},
            BW: {flag: "🇧🇼", name: "Botswana", local: "Botswana"},
            BY: {flag: "🇧🇾", name: "Belarus", local: "Беларусь"},
            BZ: {flag: "🇧🇿", name: "Belize", local: "Belize"},
            CA: {flag: "🇨🇦", name: "Canada", local: "Canada"},
            CC: {flag: "🇨🇨", name: "Cocos (Keeling) Islands", local: "Cocos (Keeling) Islands"},
            CD: {flag: "🇨🇩", name: "Democratic Republic of the Congo", local: "République Démocratique du Congo"},
            CF: {flag: "🇨🇫", name: "Central African Republic", local: "République centrafricaine"},
            CG: {flag: "🇨🇬", name: "Republic of the Congo", local: "République du Congo"},
            CH: {flag: "🇨🇭", name: "Switzerland", local: "Schweiz"},
            CI: {flag: "🇨🇮", name: "Ivory Coast", local: "Côte d'Ivoire"},
            CK: {flag: "🇨🇰", name: "Cook Islands", local: "Cook Islands"},
            CL: {flag: "🇨🇱", name: "Chile", local: "Chile"},
            CM: {flag: "🇨🇲", name: "Cameroon", local: "Cameroun"},
            CN: {flag: "🇨🇳", name: "China", local: "中国"},
            CO: {flag: "🇨🇴", name: "Colombia", local: "Colombia"},
            CR: {flag: "🇨🇷", name: "Costa Rica", local: "Costa Rica"},
            CU: {flag: "🇨🇺", name: "Cuba", local: "Cuba"},
            CV: {flag: "🇨🇻", name: "Cape Verde", local: "Cabo Verde"},
            CW: {flag: "🇨🇼", name: "Curaçao", local: "Curaçao"},
            CX: {flag: "🇨🇽", name: "Christmas Island", local: "Christmas Island"},
            CY: {flag: "🇨🇾", name: "Cyprus", local: "Κύπρος"},
            CZ: {flag: "🇨🇿", name: "Czech Republic", local: "Česká republika"},
            DE: {flag: "🇩🇪", name: "Germany", local: "Deutschland"},
            DJ: {flag: "🇩🇯", name: "Djibouti", local: "Djibouti"},
            DK: {flag: "🇩🇰", name: "Denmark", local: "Danmark"},
            DM: {flag: "🇩🇲", name: "Dominica", local: "Dominica"},
            DO: {flag: "🇩🇴", name: "Dominican Republic", local: "República Dominicana"},
            DZ: {flag: "🇩🇿", name: "Algeria", local: "الجزائر"},
            EC: {flag: "🇪🇨", name: "Ecuador", local: "Ecuador"},
            EE: {flag: "🇪🇪", name: "Estonia", local: "Eesti"},
            EG: {flag: "🇪🇬", name: "Egypt", local: "مصر"},
            EH: {flag: "🇪🇭", name: "Western Sahara", local: "الصحراء الغربية"},
            ER: {flag: "🇪🇷", name: "Eritrea", local: "إريتريا"},
            ES: {flag: "🇪🇸", name: "Spain", local: "España"},
            ET: {flag: "🇪🇹", name: "Ethiopia", local: "ኢትዮጵያ"},
            FI: {flag: "🇫🇮", name: "Finland", local: "Suomi"},
            FJ: {flag: "🇫🇯", name: "Fiji", local: "Fiji"},
            FK: {flag: "🇫🇰", name: "Falkland Islands", local: "Falkland Islands"},
            FM: {flag: "🇫🇲", name: "Federated States of Micronesia", local: "Micronesia"},
            FO: {flag: "🇫🇴", name: "Faroe Islands", local: "Føroyar"},
            FR: {flag: "🇫🇷", name: "France", local: "France"},
            GA: {flag: "🇬🇦", name: "Gabon", local: "Gabon"},
            GB: {flag: "🇬🇧", name: "United Kingdom", local: "United Kingdom"},
            GD: {flag: "🇬🇩", name: "Grenada", local: "Grenada"},
            GE: {flag: "🇬🇪", name: "Georgia", local: "საქართველო"},
            GF: {flag: "🇬🇫", name: "French Guiana", local: "Guyane française"},
            GG: {flag: "🇬🇬", name: "Guernsey", local: "Guernsey"},
            GH: {flag: "🇬🇭", name: "Ghana", local: "Ghana"},
            GI: {flag: "🇬🇮", name: "Gibraltar", local: "Gibraltar"},
            GL: {flag: "🇬🇱", name: "Greenland", local: "Kalaallit Nunaat"},
            GM: {flag: "🇬🇲", name: "Gambia", local: "Gambia"},
            GN: {flag: "🇬🇳", name: "Guinea", local: "Guinée"},
            GP: {flag: "🇬🇵", name: "Guadeloupe", local: "Guadeloupe"},
            GQ: {flag: "🇬🇶", name: "Equatorial Guinea", local: "Guinea Ecuatorial"},
            GR: {flag: "🇬🇷", name: "Greece", local: "Ελλάδα"},
            GS: {
                flag: "🇬🇸",
                name: "South Georgia and the South Sandwich Islands",
                local: "South Georgia and the South Sandwich Islands"
            },
            GT: {flag: "🇬🇹", name: "Guatemala", local: "Guatemala"},
            GU: {flag: "🇬🇺", name: "Guam", local: "Guam"},
            GW: {flag: "🇬🇼", name: "Guinea-Bissau", local: "Guiné-Bissau"},
            GY: {flag: "🇬🇾", name: "Guyana", local: "Guyana"},
            HK: {flag: "🇭🇰", name: "Hong Kong", local: "香港"},
            HM: {flag: "🇭🇲", name: "Heard Island and McDonald Islands", local: "Heard Island and McDonald Islands"},
            HN: {flag: "🇭🇳", name: "Honduras", local: "Honduras"},
            HR: {flag: "🇭🇷", name: "Croatia", local: "Hrvatska"},
            HT: {flag: "🇭🇹", name: "Haiti", local: "Haïti"},
            HU: {flag: "🇭🇺", name: "Hungary", local: "Magyarország"},
            ID: {flag: "🇮🇩", name: "Indonesia", local: "Indonesia"},
            IE: {flag: "🇮🇪", name: "Ireland", local: "Éire"},
            IL: {flag: "🇮🇱", name: "Israel", local: "ישראל"},
            IM: {flag: "🇮🇲", name: "Isle of Man", local: "Isle of Man"},
            IN: {flag: "🇮🇳", name: "India", local: "भारत"},
            IO: {flag: "🇮🇴", name: "British Indian Ocean Territory", local: "British Indian Ocean Territory"},
            IQ: {flag: "🇮🇶", name: "Iraq", local: "العراق"},
            IR: {flag: "🇮🇷", name: "Iran", local: "ایران"},
            IS: {flag: "🇮🇸", name: "Iceland", local: "Ísland"},
            IT: {flag: "🇮🇹", name: "Italy", local: "Italia"},
            JE: {flag: "🇯🇪", name: "Jersey", local: "Jersey"},
            JM: {flag: "🇯🇲", name: "Jamaica", local: "Jamaica"},
            JO: {flag: "🇯🇴", name: "Jordan", local: "الأردن"},
            JP: {flag: "🇯🇵", name: "Japan", local: "日本"},
            KE: {flag: "🇰🇪", name: "Kenya", local: "Kenya"},
            KG: {flag: "🇰🇬", name: "Kyrgyzstan", local: "Кыргызстан"},
            KH: {flag: "🇰🇭", name: "Cambodia", local: "កម្ពុជា"},
            KI: {flag: "🇰🇮", name: "Kiribati", local: "Kiribati"},
            KM: {flag: "🇰🇲", name: "Comoros", local: "Komori"},
            KN: {flag: "🇰🇳", name: "Saint Kitts and Nevis", local: "Saint Kitts and Nevis"},
            KP: {flag: "🇰🇵", name: "North Korea", local: "북한"},
            KR: {flag: "🇰🇷", name: "South Korea", local: "대한민국"},
            KW: {flag: "🇰🇼", name: "Kuwait", local: "الكويت"},
            KY: {flag: "🇰🇾", name: "Cayman Islands", local: "Cayman Islands"},
            KZ: {flag: "🇰🇿", name: "Kazakhstan", local: "Қазақстан"},
            LA: {flag: "🇱🇦", name: "Laos", local: "ລາວ"},
            LB: {flag: "🇱🇧", name: "Lebanon", local: "لبنان"},
            LC: {flag: "🇱🇨", name: "Saint Lucia", local: "Saint Lucia"},
            LI: {flag: "🇱🇮", name: "Liechtenstein", local: "Liechtenstein"},
            LK: {flag: "🇱🇰", name: "Sri Lanka", local: "ශ්‍රී ලංකා"},
            LR: {flag: "🇱🇷", name: "Liberia", local: "Liberia"},
            LS: {flag: "🇱🇸", name: "Lesotho", local: "Lesotho"},
            LT: {flag: "🇱🇹", name: "Lithuania", local: "Lietuva"},
            LU: {flag: "🇱🇺", name: "Luxembourg", local: "Luxembourg"},
            LV: {flag: "🇱🇻", name: "Latvia", local: "Latvija"},
            LY: {flag: "🇱🇾", name: "Libya", local: "ليبيا"},
            MA: {flag: "🇲🇦", name: "Morocco", local: "المغرب"},
            MC: {flag: "🇲🇨", name: "Monaco", local: "Monaco"},
            MD: {flag: "🇲🇩", name: "Moldova", local: "Moldova"},
            ME: {flag: "🇲🇪", name: "Montenegro", local: "Crna Gora"},
            MF: {flag: "🇲🇫", name: "Saint Martin", local: "Saint Martin"},
            MG: {flag: "🇲🇬", name: "Madagascar", local: "Madagasikara"},
            MH: {flag: "🇲🇭", name: "Marshall Islands", local: "M̧ajeļ"},
            MK: {flag: "🇲🇰", name: "North Macedonia", local: "Северна Македонија"},
            ML: {flag: "🇲🇱", name: "Mali", local: "Mali"},
            MM: {flag: "🇲🇲", name: "Myanmar", local: "မြန်မာ"},
            MN: {flag: "🇲🇳", name: "Mongolia", local: "Монгол"},
            MO: {flag: "🇲🇴", name: "Macao", local: "澳门"},
            MP: {flag: "🇲🇵", name: "Northern Mariana Islands", local: "Northern Mariana Islands"},
            MQ: {flag: "🇲🇶", name: "Martinique", local: "Martinique"},
            MR: {flag: "🇲🇷", name: "Mauritania", local: "موريتانيا"},
            MS: {flag: "🇲🇸", name: "Montserrat", local: "Montserrat"},
            MT: {flag: "🇲🇹", name: "Malta", local: "Malta"},
            MU: {flag: "🇲🇺", name: "Mauritius", local: "Mauritius"},
            MV: {flag: "🇲🇻", name: "Maldives", local: "Maldives"},
            MW: {flag: "🇲🇼", name: "Malawi", local: "Malawi"},
            MX: {flag: "🇲🇽", name: "Mexico", local: "México"},
            MY: {flag: "🇲🇾", name: "Malaysia", local: "Malaysia"},
            MZ: {flag: "🇲🇿", name: "Mozambique", local: "Moçambique"},
            NA: {flag: "🇳🇦", name: "Namibia", local: "Namibië"},
            NC: {flag: "🇳🇨", name: "New Caledonia", local: "Nouvelle-Calédonie"},
            NE: {flag: "🇳🇪", name: "Niger", local: "Niger"},
            NF: {flag: "🇳🇫", name: "Norfolk Island", local: "Norfolk Island"},
            NG: {flag: "🇳🇬", name: "Nigeria", local: "Nigeria"},
            NI: {flag: "🇳🇮", name: "Nicaragua", local: "Nicaragua"},
            NL: {flag: "🇳🇱", name: "Netherlands", local: "Nederland"},
            NO: {flag: "🇳🇴", name: "Norway", local: "Norge"},
            NP: {flag: "🇳🇵", name: "Nepal", local: "नेपाल"},
            NR: {flag: "🇳🇷", name: "Nauru", local: "Nauru"},
            NU: {flag: "🇳🇺", name: "Niue", local: "Niuē"},
            NZ: {flag: "🇳🇿", name: "New Zealand", local: "Aotearoa"},
            OM: {flag: "🇴🇲", name: "Oman", local: "عمان"},
            PA: {flag: "🇵🇦", name: "Panama", local: "Panamá"},
            PE: {flag: "🇵🇪", name: "Peru", local: "Perú"},
            PF: {flag: "🇵🇫", name: "French Polynesia", local: "Polynésie française"},
            PG: {flag: "🇵🇬", name: "Papua New Guinea", local: "Papua Niugini"},
            PH: {flag: "🇵🇭", name: "Philippines", local: "Pilipinas"},
            PK: {flag: "🇵🇰", name: "Pakistan", local: "پاکستان"},
            PL: {flag: "🇵🇱", name: "Poland", local: "Polska"},
            PM: {flag: "🇵🇲", name: "Saint Pierre and Miquelon", local: "Saint-Pierre-et-Miquelon"},
            PN: {flag: "🇵🇳", name: "Pitcairn Islands", local: "Pitcairn"},
            PR: {flag: "🇵🇷", name: "Puerto Rico", local: "Puerto Rico"},
            PS: {flag: "🇵🇸", name: "Palestinian Territories", local: "فلسطين"},
            PT: {flag: "🇵🇹", name: "Portugal", local: "Portugal"},
            PW: {flag: "🇵🇼", name: "Palau", local: "Belau"},
            PY: {flag: "🇵🇾", name: "Paraguay", local: "Paraguay"},
            QA: {flag: "🇶🇦", name: "Qatar", local: "قطر"},
            RE: {flag: "🇷🇪", name: "Réunion", local: "La Réunion"},
            RO: {flag: "🇷🇴", name: "Romania", local: "România"},
            RS: {flag: "🇷🇸", name: "Serbia", local: "Србија"},
            RU: {flag: "🇷🇺", name: "Russia", local: "Россия"},
            RW: {flag: "🇷🇼", name: "Rwanda", local: "Rwanda"},
            SA: {flag: "🇸🇦", name: "Saudi Arabia", local: "المملكة العربية السعودية"},
            SB: {flag: "🇸🇧", name: "Solomon Islands", local: "Solomon Islands"},
            SC: {flag: "🇸🇨", name: "Seychelles", local: "Seychelles"},
            SD: {flag: "🇸🇩", name: "Sudan", local: "السودان"},
            SE: {flag: "🇸🇪", name: "Sweden", local: "Sverige"},
            SG: {flag: "🇸🇬", name: "Singapore", local: "Singapore"},
            SH: {flag: "🇸🇭", name: "Saint Helena", local: "Saint Helena"},
            SI: {flag: "🇸🇮", name: "Slovenia", local: "Slovenija"},
            SJ: {flag: "🇸🇯", name: "Svalbard and Jan Mayen", local: "Svalbard og Jan Mayen"},
            SK: {flag: "🇸🇰", name: "Slovakia", local: "Slovensko"},
            SL: {flag: "🇸🇱", name: "Sierra Leone", local: "Sierra Leone"},
            SM: {flag: "🇸🇲", name: "San Marino", local: "San Marino"},
            SN: {flag: "🇸🇳", name: "Senegal", local: "Sénégal"},
            SO: {flag: "🇸🇴", name: "Somalia", local: "Soomaaliya"},
            SR: {flag: "🇸🇷", name: "Suriname", local: "Suriname"},
            SS: {flag: "🇸🇸", name: "South Sudan", local: "جنوب السودان"},
            ST: {flag: "🇸🇹", name: "São Tomé and Príncipe", local: "São Tomé e Príncipe"},
            SV: {flag: "🇸🇻", name: "El Salvador", local: "El Salvador"},
            SX: {flag: "🇸🇽", name: "Sint Maarten", local: "Sint Maarten"},
            SY: {flag: "🇸🇾", name: "Syria", local: "سوريا"},
            SZ: {flag: "🇸🇿", name: "Swaziland", local: "Sihlangu"},
            TC: {flag: "🇹🇨", name: "Turks and Caicos Islands", local: "Turks and Caicos Islands"},
            TD: {flag: "🇹🇩", name: "Chad", local: "Tchad"},
            TF: {
                flag: "🇹🇫",
                name: "French Southern and Antarctic Lands",
                local: "Terres australes et antarctiques françaises"
            },
            TG: {flag: "🇹🇬", name: "Togo", local: "Togo"},
            TH: {flag: "🇹🇭", name: "Thailand", local: "ประเทศไทย"},
            TJ: {flag: "🇹🇯", name: "Tajikistan", local: "Таджикистан"},
            TK: {flag: "🇹🇰", name: "Tokelau", local: "Tokelau"},
            TL: {flag: "🇹🇱", name: "Timor-Leste", local: "Timor-Leste"},
            TM: {flag: "🇹🇲", name: "Turkmenistan", local: "Türkmenistan"},
            TN: {flag: "🇹🇳", name: "Tunisia", local: "تونس"},
            TO: {flag: "🇹🇴", name: "Tonga", local: "Tonga"},
            TR: {flag: "🇹🇷", name: "Turkey", local: "Türkiye"},
            TT: {flag: "🇹🇹", name: "Trinidad and Tobago", local: "Trinidad and Tobago"},
            TV: {flag: "🇹🇻", name: "Tuvalu", local: "Tuvalu"},
            TW: {flag: "🇹🇼", name: "Taiwan", local: "台灣"},
            TZ: {flag: "🇹🇿", name: "Tanzania", local: "Tanzania"},
            UA: {flag: "🇺🇦", name: "Ukraine", local: "Україна"},
            UG: {flag: "🇺🇬", name: "Uganda", local: "Uganda"},
            UM: {flag: "🇺🇲", name: "U.S. Minor Outlying Islands", local: "U.S. Minor Outlying Islands"},
            US: {flag: "🇺🇸", name: "United States", local: "United States"},
            UY: {flag: "🇺🇾", name: "Uruguay", local: "Uruguay"},
            UZ: {flag: "🇺🇿", name: "Uzbekistan", local: "O'zbekiston"},
            VA: {flag: "🇻🇦", name: "Vatican City", local: "Città del Vaticano"},
            VC: {flag: "🇻🇨", name: "Saint Vincent and the Grenadines", local: "Saint Vincent and the Grenadines"},
            VE: {flag: "🇻🇪", name: "Venezuela", local: "Venezuela"},
            VG: {flag: "🇻🇬", name: "British Virgin Islands", local: "British Virgin Islands"},
            VI: {flag: "🇻🇮", name: "U.S. Virgin Islands", local: "U.S. Virgin Islands"},
            VN: {flag: "🇻🇳", name: "Vietnam", local: "Việt Nam"},
            VU: {flag: "🇻🇺", name: "Vanuatu", local: "Vanuatu"},
            WF: {flag: "🇼🇫", name: "Wallis and Futuna", local: "Wallis et Futuna"},
            WS: {flag: "🇼🇸", name: "Samoa", local: "Samoa"},
            YE: {flag: "🇾🇪", name: "Yemen", local: "اليمن"},
            YT: {flag: "🇾🇹", name: "Mayotte", local: "Mayotte"},
            ZA: {flag: "🇿🇦", name: "South Africa", local: "South Africa"},
            ZM: {flag: "🇿🇲", name: "Zambia", local: "Zambia"},
            ZW: {flag: "🇿🇼", name: "Zimbabwe", local: "Zimbabwe"}
        }
    },
    languages: {
        get() {
            return Object.entries(document.languageInfo).filter(([iso])=>/^[a-z]/.test(iso));
        }
    },
    countries: {
        get() {
            return Object.entries(document.languageInfo).filter(([iso])=>/^[A-Z]/.test(iso));
        }
    }
});
document.adoptStyleSheets(
    ["flags", ":root {" + Object.entries(document.languageInfo).map(([iso, {flag}]) => `--flag-${iso}: "${flag}";`).join("") + "}"],
    ["locale-flags", Object.keys(document.languageInfo).map(iso => {
        return (/^[A-Z]/.test(iso) ? `[country="${iso}"]` : `[lang="${iso}"]`) + `{ --flag: var(--flag-${iso}); }`
    }).join("")]
);

